"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/SmallScreenHeader.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Bx_template = require("../../components/Bx/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_attrs0 = {
        "class": "position-fixed zindex-1 w-100 d-lg-none d-block theme-bg px-2 py-1"
      },
    marko_attrs1 = {
        "class": "cursor-pointer"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("f7a75c"),
    marko_node0 = marko_createElement("div", {
        style: "height:4rem",
        "class": "d-md-none d-block"
      }, "3", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.be("span", marko_attrs1, "1", component, null, 0, {
      onclick: __component.d("click", () => GState.menu.show(), false)
    });

  Bx_tag({
      type: "menu",
      class: "btn-show-menu font-large-1"
    }, out, __component, "2");

  out.ee();

  out.ee();

  out.n(marko_node0, component);
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
